import {
    MDBBtn,
    MDBCheckbox,
    MDBChip,
    MDBCol,
    MDBDatatable,
    MDBDatepicker,
    MDBInput,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBRadio,
    MDBRow,
    MDBSelect,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane,
    MDBTextArea
} from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import TransferNumbers from './TransferNumbers';
import ReviewNumbers from './ReviewNumbers';
import NumbersToDestination from './NumbersToDestination';
import NumbersAccountInfo from './NumbersAccountInfo';
import NumbersServiceAddress from './NumbersServiceAddress';
import NumbersAreaService from './NumbersAreaService';
import NumbersNotification from './NumbersNotification';
import { set, useForm } from 'react-hook-form';
import { portingSteps, portingStepsForm } from '../../../../apiclients/streamsapi_bridge';
import { formattedNumber } from '../AddRemoveNumbers';

function TNLocalStep1({ nextPageclick,
    portingType,
    register,
    watch,
    setValue,
    clearErrors,
    handleSubmit,
    formState,
    setError,
    setflowStep,
    flowStep,
    setbackFlag,
    backFlag,
    assignedNumbersDetails,
    setassignedNumbersDetails,
    setUpdateDestinationObj,
    updateDestinationObj,
    setupdateTempNumObj,
    updateTempNumObj,
    areaOfServiceDetails,
    setareaOfServiceDetails,
    updateAllArea,
    setupdateAllArea,
    destinationTypes,
    setdestinationTypes,
    reset,
    setmaxNumFileUpload,
    settelePhoneList,
    drafFlag,
    setdrafFlag,
    setorderID,
    orderID,
    Controller,
    control,
    setIsloading,
    setskipFlag, //for tn validation only
    skipFlag,
    resetField,
    skipfields,
    setSuccessMessage,
    setsavedDraftData,
    isChanged,
    currentStep,
    setcurrentStep,
    reloadassigned,
    setreloadassigned,
    portingNumbers,
    setportingNumbers,
    assignedErrors,
    areaErrors,
    setassignedErrors,
    setAreaErrors,

}) {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();


    const [verticalActive, setVerticalActive] = useState('tab1');
    const [visitedTabs, setVisitedTabs] = useState(['tab1']);



    const [reloadarea, setreloadarea] = useState(false);
    const [executefalg, setExeuteFlag] = useState(false);

    // const [assignedNumbersDetails, setassignedNumbersDetails] = useState([]);

    // const [areaOfServiceDetails, setareaOfServiceDetails] = useState([]);


    const { dirtyFields, isDirty, errors } = formState;


    useEffect(() => {
        if (flowStep && parseInt(flowStep) !== 0 && (backFlag || drafFlag)) {
            if (!drafFlag) {
                setbackFlag(false);
                setcurrentStep(flowStep);
                if (portingType === 3) {
                    const tabid = flowStep === 3 ? "tab4" : flowStep === 4 ? "tab5" : "tab" + flowStep;
                    setVerticalActive(tabid);
                    const number = tabid.replace(/\D/g, '') * 1;
                    for (let i = 1; i <= number; i++) {
                        setVisitedTabs((prev) => [...prev, `tab${i}`]);
                    }
                } else {
                    setVerticalActive("tab7");
                    for (let i = 1; i <= 7; i++) {
                        setVisitedTabs((prev) => [...prev, `tab${i}`]);
                    }
                }
            } else {
                let currstep = "tab1"
                setbackFlag(false);
                setdrafFlag(false);
                if (portingType === 1) {
                    currstep = flowStep === 6 ? "tab7" : "tab" + flowStep;

                }
                if (portingType === 2) {
                    currstep = "tab" + flowStep;

                }
                if (portingType === 3) {
                    currstep = flowStep === 3 ? "tab4" : flowStep === 4 ? "tab5" : "tab" + flowStep;

                }

                const number = currstep.replace(/\D/g, '') * 1;
                setcurrentStep(flowStep);
                setVerticalActive(currstep);
                for (let i = 1; i <= number; i++) {
                    setVisitedTabs((prev) => [...prev, `tab${i}`]);
                }
            }
        }

    }, [flowStep]);

    const handleSkip = () => {
        // debugger;
        clearErrors();
        if (currentStep === 3) {
            Object.keys(skipfields?.acc_info).forEach((key) =>
                setValue(`acc_info.${key}`, skipfields?.acc_info[key], { shouldDirty: true })
            )
            // reset((prev) => ({ ...prev, acc_info: skipfields?.acc_info }));

            setskipFlag(1);
        } else if (currentStep === 4) {
            setskipFlag(skipFlag === 0 ? 2 : 3);
            Object.keys(skipfields.service_addr).forEach((key) =>
                setValue(`service_addr.${key}`, skipfields.service_addr[key], { shouldDirty: true })
            );
            // reset((prev) => ({ ...prev, service_addr: skipfields?.service_addr }));

        }

        const nextstep = parseInt(currentStep) + 1;
        setcurrentStep(nextstep);
        const tabs = ['tab1', 'tab2', 'tab4', 'tab5'];

        const currentIndex = tabs.indexOf(verticalActive);

        if (currentIndex < tabs.length - 1) {
            setVerticalActive(tabs[currentIndex + 1]);
            if (!visitedTabs.includes(tabs[currentIndex + 1])) {
                setVisitedTabs([...visitedTabs, tabs[currentIndex + 1]]);
            }

        } else {
            setflowStep(nextstep);
            nextPageclick();

        }
    }
    const [alertMessage, setalertMessage] = useState("");
    const [alertnumbers, setalertnumbers] = useState([]);
    const [newTabObject, setnewTabObject] = useState(null);
    const [numberLimitAlert, setNumberLimitAlert] = useState(false);

    const toggleOpen = () => setNumberLimitAlert(!numberLimitAlert);

    const handleNextClick = async (data) => {
        // if (dirtyFields) {
        // debugger;
        let keys = {};
        let keysData = {};
        let update = {};

        console.log("dirtyFields :::::::::::::::: " + JSON.stringify(dirtyFields));
        console.log("data :::::::::::::::: " + JSON.stringify(data));
        if (!(verticalActive === "tab2")) {
            switch (currentStep) {
                case 1:
                    keys = dirtyFields.enter_num;
                    keysData = data.enter_num;
                    update = {
                        enter_num: {}
                    }
                    break;
                case 3:
                    if (portingType === 3) {
                        keys = dirtyFields.acc_info;
                        keysData = data.acc_info;
                        update = {
                            acc_info: {}
                        }
                    } else {
                        keys = dirtyFields.assign;
                        keysData = data.assign;
                        console.log("assihned data ::::::::: " + JSON.stringify(data.assign));
                        update = {
                            assign: []
                        }
                    }
                    break;
                case 4:
                    if (portingType === 3) {
                        keys = dirtyFields.service_addr;
                        keysData = data.service_addr;
                        update = {
                            service_addr: {}
                        }
                    } else {
                        keys = dirtyFields.acc_info;
                        keysData = data.acc_info;
                        update = {
                            acc_info: {}
                        }
                    }
                    break
                case 5:
                    keys = dirtyFields.service_addr;
                    keysData = data.service_addr;
                    update = {
                        service_addr: {}
                    }
                    break
                case 6:
                    if (portingType === 2) {
                        keys = dirtyFields.area_of_service;
                        keysData = data.area_of_service;
                        update = {
                            area_of_service: []
                        }
                    } else {
                        keys = dirtyFields.notifs_comments;
                        keysData = data.notifs_comments;
                        update = {
                            notifs_comments: {}
                        }
                    }
                    break
                case 7:
                    keys = dirtyFields.notifs_comments;
                    keysData = data.notifs_comments;
                    update = {
                        notifs_comments: {}
                    }
                    break
            }
            let modifiedData = {};
            console.log("Modified keys ::::::::::: " + JSON.stringify(keys));
            console.log("Modified data value ::::::::::: " + JSON.stringify(keysData));
            //debugger;

            if (currentStep === 4 || currentStep === 5 || currentStep === 3 || currentStep === 1 || currentStep === 7) {
                if (!validateInputs(keysData)) {
                    return;
                }
            }



            // debugger;
            if (currentStep !== 1) {
                if (!(Array.isArray(keysData))) {
                    for (const field of Object.keys(keys)) {
                        modifiedData[field] = keysData[field];
                    }

                } else {
                    // modifiedData.ddd = [...keysData];
                    modifiedData = [...keysData];

                }
            }

            if (currentStep === 1) {
                if (portingType !== 3) {
                    modifiedData.ddd = keysData.ddd;
                }
                if (keys && keys.number) {
                    modifiedData.number = keysData.number;
                }
            }
            if (currentStep === 4 && parseInt(portingType) === 2 && !(Array.isArray(keysData))) {
                modifiedData.porting_num_type = keysData.porting_num_type;

            }
            if (verticalActive === 'tab7') {
                modifiedData.send_email_to_admin = keysData.send_email_to_admin;

            }
            const finalupdate = Object.keys(update).reduce((acc, key) => {
                acc[key] = modifiedData;
                return acc;
            }, {});

            finalupdate.reqid = parseInt(portingType) === 1 ? 91 : parseInt(portingType) === 2 ? 95 : 96;
            finalupdate.siteid = JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid;
            if (orderID) {
                finalupdate.orderid = orderID;
            }
            finalupdate.port_type = parseInt(portingType);
            finalupdate.flow_step = parseInt(currentStep);
            console.log("final final update Field is ::::::::::: " + JSON.stringify(finalupdate));
            setIsloading(true);
            let saverep = await portingSteps(finalupdate);
            setIsloading(false);

            console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);
            let saverepeMsg = await saverep.json();
            console.log(
                "response of next:::" + JSON.stringify(saverepeMsg)
            );
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                if (parseInt(currentStep) === 1 && saverepeMsg.alert) {

                    const numbersalert = saverepeMsg.alert.message.split(":");
                    if (numbersalert && numbersalert.length > 0) {
                        setalertMessage(numbersalert[0]);
                        setalertnumbers(numbersalert[1]?.split(", ") ?? []);
                        setnewTabObject(saverepeMsg);
                        setNumberLimitAlert(true);
                    }

                } else {
                    navigateNewTab(saverepeMsg);
                }
            } else {
                if (saverepeMsg.message?.errors) {
                    let tempasserror = [];
                    let temparrerror = [];
                    saverepeMsg.message.errors.forEach((err) => {
                        if (err.position !== undefined) {
                            if (err.param_name.indexOf("assign") != -1) {
                                tempasserror.push(err);
                            } else if (err.param_name.indexOf("area_of_service") != -1) {
                                temparrerror.push(err);
                            }
                        } else {
                            setError(err.param_name, {
                                type: "server",
                                message: err.message,
                            });
                            const fieldElement = document.querySelector(
                                `input[name="${err.param_name}"]`
                            );
                            if (fieldElement) {
                                fieldElement.focus();
                                fieldElement.scrollIntoView({ behavior: "smooth" });
                            }
                        }
                    });
                    if (tempasserror && tempasserror.length > 0 && currentStep === 3) {
                        setassignedErrors(tempasserror);

                    }
                    if (temparrerror && temparrerror.length > 0 && currentStep === 6) {
                        setAreaErrors(temparrerror);

                    }
                } else {
                    //   setInternalError(true);
                }
            }


        } else {
            setIsloading(true);
            setcurrentStep(parseInt(currentStep) + 1);
            // if (portingType === 3) {
            //     setcurrentStep(parseInt(currentStep) + 2);
            // }
            let tabs = ['tab1', 'tab2', 'tab3', 'tab4', 'tab5', 'tab7'];
            if (portingType === 2) {
                tabs = ['tab1', 'tab2', 'tab3', 'tab4', 'tab5', 'tab6', 'tab7'];

            } else if (portingType === 3) {
                tabs = ['tab1', 'tab2', 'tab4', 'tab5', 'tab6'];
            }
            const currentIndex = tabs.indexOf(verticalActive);
            if (currentIndex < tabs.length - 1) {
                setVerticalActive(tabs[currentIndex + 1]);
                if (!visitedTabs.includes(tabs[currentIndex + 1])) {
                    setVisitedTabs([...visitedTabs, tabs[currentIndex + 1]]);
                }
            } else {
                nextPageclick();
            }
            const currentAssignedNumberSet = assignedNumbersDetails.map((detail) => detail.number).sort().join(",");
            const latestPortingNumberSet = [...portingNumbers].sort().join(",");
            if (assignedNumbersDetails.length === 0) {
                const assignedNumber = portingNumbers.map((number) => ({ dest: "", number: number, dest_type: "", temp_num: [] }));
                setValue("assign", assignedNumber, { shouldDirty: true });
                setassignedNumbersDetails(assignedNumber ?? []);
                setExeuteFlag(true);
            } else if (currentAssignedNumberSet !== latestPortingNumberSet) {
                // The set of numbers changed since assignedNumbersDetails was last
                // built (e.g. numbers removed/added after revisiting Enter Number(s)
                // via Previous) - rebuild from the latest portingNumbers instead of
                // keeping the stale list, while still preserving any already-fetched
                // destination data for numbers that are still present.
                const assignedNumber = portingNumbers.map((number) => {
                    const existing = assignedNumbersDetails.find((detail) => detail.number === number);
                    return existing ?? { dest: "", number: number, dest_type: "", temp_num: [] };
                });
                // Mirror NumbersToDestination.jsx's requiredValues pattern: the
                // "assign" field submitted to the API must only contain the
                // supported fields (destinations/tempNumber/*error are UI-only
                // caching fields kept in assignedNumbersDetails), and dest/dest_type
                // must stay strings, matching setTheAllParanValues' normalization.
                const requiredValues = assignedNumber.map(
                    ({ destinations, tempNumber, dest_typeerror, desterror, temp_numerror, ...rest }) => ({
                        ...rest,
                        dest: rest.dest && rest.dest != 0 ? rest.dest + "" : "",
                        dest_type: rest.dest_type && rest.dest_type != 0 ? rest.dest_type + "" : "",
                    })
                );
                setValue("assign", requiredValues, { shouldDirty: true });
                setassignedNumbersDetails(assignedNumber ?? []);
                setreloadassigned(true);
            } else {
                setassignedNumbersDetails(assignedNumbersDetails ?? []);
                setreloadassigned(true);
            }
            setIsloading(false);
        }

        // }
    };

    function navigateNewTab(saverepeMsg) {
        const nextstep = parseInt(currentStep) + 1;
        setcurrentStep(nextstep);
        const sessionisFive9Account =
            sessionStorage.getItem("admin_session") &&
                JSON.parse(sessionStorage.getItem("admin_session"))?.isFive9Account
                ? JSON.parse(sessionStorage.getItem("admin_session")).isFive9Account
                : "";
        const sessionisfive9AccType =
            sessionStorage.getItem("admin_session") &&
                JSON.parse(sessionStorage.getItem("admin_session"))?.five9AccType
                ? JSON.parse(sessionStorage.getItem("admin_session")).five9AccType
                : "";
        if (verticalActive === 'tab1') {
            setportingNumbers(saverepeMsg?.number ?? []);
            setorderID(saverepeMsg?.orderid ? parseInt(saverepeMsg.orderid) : 0);
            settelePhoneList(saverepeMsg?.number ?? []);
            let destTypes = saverepeMsg?.dest_type ?? [];

            const isFive9 = sessionisFive9Account === true || sessionisFive9Account === "true";
            const five9Type = Number(sessionisfive9AccType);

            if (isFive9 && five9Type === 1) {
                // Show only CCaaS
                destTypes = destTypes.filter(item => item.value === "14");
            } else {
                // For other cases, remove CCaaS unless five9Type is 2
                destTypes = destTypes.filter(item => {
                    if (item.value === "14") {
                        return isFive9 && five9Type === 2;
                    }
                    return true;
                });
            }
            setdestinationTypes(destTypes);
            const updataAccInfo = saverepeMsg?.acc_info ?? {};
            const updatenotify = saverepeMsg?.notifs_comments ?? {};
            setmaxNumFileUpload(saverepeMsg?.restrictions ? parseInt(saverepeMsg?.restrictions) : 10);
            if (Object.keys(updataAccInfo).length > 0) {
                for (const field of Object.keys(updataAccInfo)) {
                    if (portingType === 2 && (field === "curr_carrier_name")) {
                        continue;
                    }
                    if (field !== "title" && field !== "name_listed_on_acc") {
                        setValue(
                            `acc_info.${field}`,
                            (Number.isInteger(updataAccInfo[field]) ? parseInt(updataAccInfo[field]) : updataAccInfo[field] + ""),
                            { shouldDirty: true }
                        );
                    }
                }
            }

            if (Object.keys(updatenotify).length > 0) {
                for (const field of Object.keys(updatenotify)) {

                    setValue(
                        `notifs_comments.${field}`,
                        (Number.isInteger(updatenotify[field]) ? parseInt(updatenotify[field]) : typeof updatenotify[field] === 'boolean' ? updatenotify[field] : updatenotify[field] + ""),
                        { shouldDirty: true }
                    );
                }

            }
        }
        if (verticalActive === 'tab5' && parseInt(portingType) === 2) {
            if (portingNumbers.length > 0 && areaOfServiceDetails.length === 0) {
                const assignedNumber = portingNumbers.map((number) => ({ tfn_num: parseInt(number), area_of_service: -1 }));
                setValue("area_of_service", assignedNumber, { shouldDirty: true });
                setareaOfServiceDetails(assignedNumber ?? []);
            } else {
                setValue("area_of_service", areaOfServiceDetails, { shouldDirty: true });
                setareaOfServiceDetails(areaOfServiceDetails ?? []);
            }
        }
        let tabs = ['tab1', 'tab2', 'tab3', 'tab4', 'tab5', 'tab7'];
        if (portingType === 2) {
            tabs = ['tab1', 'tab2', 'tab3', 'tab4', 'tab5', 'tab6', 'tab7'];
        } else if (portingType === 3) {
            tabs = ['tab1', 'tab2', 'tab4', 'tab5'];
        }
        const currentIndex = tabs.indexOf(verticalActive);
        if (currentIndex < tabs.length - 1) {
            setVerticalActive(tabs[currentIndex + 1]);
            if (!visitedTabs.includes(tabs[currentIndex + 1])) {
                setVisitedTabs([...visitedTabs, tabs[currentIndex + 1]]);
            }

        } else {
            setflowStep(nextstep);
            nextPageclick();

        }
    }

    function prepareFinalJson(dirtyFields, data) {
        const modifiedData = {};

        function recurse(dirtyFields, data, modifiedData) {
            for (const field of Object.keys(dirtyFields)) {
                if (dirtyFields[field] && data.hasOwnProperty(field)) {
                    if (typeof data[field] === "object" && !Array.isArray(data[field])) {
                        modifiedData[field] = {};
                        recurse(dirtyFields[field], data[field], modifiedData[field]);
                    } else {
                        modifiedData[field] = data[field];
                    }
                }
            }
        }

        recurse(dirtyFields, data, modifiedData);
        return modifiedData;
    }

    const stepFieldMap = {
        1: ["enter_num"],
        2: ["review_num"], // adjust if you actually have this section
        3: portingType === 3 ? ["acc_info"] : ["assign"],
        4: portingType === 3 ? ["service_addr"] : ["acc_info"],
        5: ["service_addr"],
        6: portingType === 2 ? ["area_of_service"] : ["notifs_comments"],
        7: ["notifs_comments"]
    };

    const allowedFields = [];
    for (let step = 1; step <= currentStep; step++) {
        allowedFields.push(...(stepFieldMap[step] || []));
    }

    const handleSaveDraft = async (data) => {

        if (Object.keys(dirtyFields).length > 0) {
            const formData = new FormData();

            formData.append(
                "siteid",
                JSON.parse(sessionStorage.getItem("admin_session")).siteid
            );
            formData.append("reqid", parseInt(portingType) === 1 ? 91 : parseInt(portingType) === 2 ? 95 : 96);
            formData.append("port_type", parseInt(portingType));
            formData.append("flow_step", parseInt(currentStep));
            if (orderID) {
                formData.append("orderid", orderID);
            }
            formData.append("save_as_draft", true);
            for (const field of Object.keys(dirtyFields)) {
                if (!allowedFields.includes(field)) continue;
                let modifiedData = {};
                if (dirtyFields[field] && data.hasOwnProperty(field)) {
                    if (typeof data[field] === "object" && !Array.isArray(data[field])) {
                        for (const subfield of Object.keys(dirtyFields[field])) {
                            if (data[field].hasOwnProperty(subfield)) {
                                modifiedData[subfield] = data[field][subfield];
                            }
                        }
                        if (field === "acc_info" && portingType === 2) {
                            modifiedData.porting_num_type = data[field]["porting_num_type"];
                        }
                        if (field === "notifs_comments") {
                            modifiedData.send_email_to_admin =
                                data[field]["send_email_to_admin"];
                        }

                        formData.append(field, JSON.stringify(modifiedData));
                    } else {
                        modifiedData = [...data[field]];
                        formData.append(field, JSON.stringify(modifiedData));
                    }
                }
            }

            // const modifiedField = prepareFinalJson(dirtyFields, data);
            // console.log("modifiedField :::: " + JSON.stringify(modifiedField));
            // console.log("modifiedField :::: " + JSON.stringify(data));
            for (let [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
            }
            let saverep = await portingStepsForm(formData);
            console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);

            let saverepeMsg = await saverep.json();
            console.log(
                "response of next:::" + JSON.stringify(saverepeMsg)
            );

            if (saverepeMsg?.status && saverepeMsg?.status == "success") {
                setsavedDraftData(data);
                setSuccessMessage(saverepeMsg.message);
                setorderID(saverepeMsg?.orderid ? parseInt(saverepeMsg.orderid) : "");

            } else {
                if (saverepeMsg.message?.errors) {
                    let tempasserror = [];
                    let temparrerror = [];
                    saverepeMsg.message.errors.forEach((err) => {
                        if (err.position) {
                            if (err.param_name.indexOf("assign") != -1) {
                                tempasserror.push(err);
                            } else if (err.param_name.indexOf("area_of_service") != -1) {
                                temparrerror.push(err);
                            }
                        } else {
                            setError(err.param_name, {
                                type: "server",
                                message: err.message,
                            });
                            const fieldElement = document.querySelector(
                                `input[name="${err.param_name}"]`
                            );
                            if (fieldElement) {
                                fieldElement.focus();
                                fieldElement.scrollIntoView({ behavior: "smooth" });
                            }
                        }
                    });
                    if (tempasserror && tempasserror.length > 0 && currentStep === 3) {
                        setassignedErrors(tempasserror);

                    }
                    if (temparrerror && temparrerror.length > 0 && currentStep === 6) {
                        setAreaErrors(temparrerror);

                    }
                } else {
                    //   setInternalError(true);
                }
            }

            // }




        }
    }



    function validateInputs(keysData) {
        let valid = true;

        for (const field of Object.keys(keysData)) {
            if ((currentStep === 4 || currentStep === 1) && portingType !== 3) {
                if (portingType === 1) {
                    // if (field === "title" && keysData[field] === "") {
                    //     setError("acc_info.title", {
                    //         message: "Title is required.",
                    //     });
                    //     valid = false;

                    // }
                    if (field === "curr_carrier_name" && keysData[field] === "") {
                        setError("acc_info.curr_carrier_name", {
                            message: "Carrier is required.",
                        });
                        valid = false;

                    }
                    // if (field === "name_listed_on_acc" && keysData[field] === "") {
                    //     setError("acc_info.name_listed_on_acc", {
                    //         message: "Name Listed on account is required.",
                    //     });
                    //     valid = false;

                    // }
                    if (field === "caller_id_name" && keysData[field] === "") {
                        setError("acc_info.caller_id_name", {
                            message: "Caller Id Name is required.",
                        });
                        valid = false;

                    }
                    if (field === "number" && keysData[field] === "") {
                        setError("enter_num.number", {
                            message: "Please enter at least one phone number to continue.",
                        });
                        valid = false;
                    }

                    if (field === "ddd" && keysData[field] === "") {
                        setError("enter_num.ddd", {
                            message: "Please enter the desired due date.",
                        });
                        valid = false;
                    }

                }

                if (field === "first_name" && keysData[field] === "") {
                    setError("acc_info.first_name", {
                        message: "First Name is required.",
                    });
                    valid = false;

                }
                if (field === "last_name" && keysData[field] === "") {
                    setError("acc_info.last_name", {
                        message: "Last Name is required.",
                    });
                    valid = false;

                }
                if (field === "company_name" && keysData[field] === "") {
                    setError("acc_info.company_name", {
                        message: "Company Name is required.",
                    });
                    valid = false;

                }
                if (field === "acc_num" && keysData[field] === "") {
                    setError("acc_info.acc_num", {
                        message: "Account Number is required.",
                    });
                    valid = false;

                }
                if (field === "bill_tele_num" && keysData[field] === "") {
                    setError("acc_info.bill_tele_num", {
                        message: "Billing Telephone Number is required.",
                    });
                    valid = false;

                }

                if (field === "number" && keysData[field] === "") {
                    setError("enter_num.number", {
                        message: "Please enter at least one phone number to continue.",
                    });
                    valid = false;
                }

                if (field === "ddd" && keysData[field] === "") {
                    setError("enter_num.ddd", {
                        message: "Please enter the desired due date.",
                    });
                    valid = false;
                }
                
                if (field === "contact_ph_num" && keysData[field] === "") {
                    setError("notifs_comments.contact_ph_num", {
                        message: "Contact Number is required.",
                    });
                    valid = false;
                }
                if(portingType === 2){
                    if (field === "contact_title" && keysData[field] === "") {
                        setError("acc_info.contact_title", {
                            message: "Contact Title is required.",
                        });
                        valid = false;
                    }
                }
            } else {
                if (portingType === 3) {
                    if (field === "bill_tele_num" && keysData[field] === "") {
                        setError("acc_info.bill_tele_num", {
                            message: "Billing Telephone Number is required.",
                        });
                        valid = false;
                    }
                    if (field === "acc_num" && keysData[field] === "") {
                        setError("acc_info.acc_num", {
                            message: "Account Number is required.",
                        });
                        valid = false;

                    }
                    if (field === "first_name" && keysData[field] === "") {
                        setError("acc_info.first_name", {
                            message: "First Name is required.",
                        });
                        valid = false;

                    }
                    if (field === "last_name" && keysData[field] === "") {
                        setError("acc_info.last_name", {
                            message: "Last Name is required.",
                        });
                        valid = false;

                    }
                    if (field === "company_name" && keysData[field] === "") {
                        setError("acc_info.company_name", {
                            message: "Company Name is required.",
                        });
                        valid = false;

                    }
                    // if (field === "title" && keysData[field] === "") {
                    //     setError("acc_info.title", {
                    //         message: "Title is required.",
                    //     });
                    //     valid = false;

                    // }
                    if (field === "curr_carrier_name" && keysData[field] === "") {
                        setError("acc_info.curr_carrier_name", {
                            message: "Carrier is required.",
                        });
                        valid = false;

                    }
                    // if (field === "name_listed_on_acc" && keysData[field] === "") {
                    //     setError("acc_info.name_listed_on_acc", {
                    //         message: "Name Listed on account is required.",
                    //     });
                    //     valid = false;

                    // }

                    if (field === "number" && keysData[field] === "") {
                        setError("enter_num.number", {
                            message: "Please enter at least one phone number to continue.",
                        });
                        valid = false;
                    }

                }

                if (field === "street_num" && keysData[field] === "") {
                    setError("service_addr.street_num", {
                        message: "Street Number Name is required.",
                    });
                    valid = false;

                }
                if (field === "city" && keysData[field] === "") {
                    setError("service_addr.city", {
                        message: "City Name is required.",
                    });
                    valid = false;

                }
                if (field === "zip" && keysData[field] === "") {
                    setError("service_addr.zip", {
                        message: "Zip code Name is required.",
                    });
                    valid = false;

                }
                if (field === "street_name" && keysData[field] === "") {
                    setError("service_addr.street_name", {
                        message: "Street Name is required.",
                    });
                    valid = false;

                }
                if (field === "state" && keysData[field] === "") {
                    setError("service_addr.state", {
                        message: "State Name is required.",
                    });
                    valid = false;

                }

                if (portingType === 2) {
                    if (field === "carrier_acc_num" && keysData[field] === "") {
                        setError("service_addr.carrier_acc_num", {
                            message: "Carrier Account Number is required.",
                        });
                        valid = false;

                    }
                    // if (field === "acc_btn" && keysData[field] === "") {
                    //     setError("service_addr.acc_btn", {
                    //         message: "Account BTN is required.",
                    //     });
                    //     valid = false;

                    // }
                    if (field === "carrier_name" && keysData[field] === "") {
                        setError("service_addr.carrier_name", {
                            message: "Carrier Name is required.",
                        });
                        valid = false;

                    }

                }
            }


        }
        return valid;

    }

    // Form-level Tab key handler.
    // MDB Modal adds a window-level keydown listener that intercepts ALL Tab presses
    // and calls preventDefault(), preventing natural focus movement. It builds a
    // static element list at modal-open time that includes inputs from hidden panes,
    // so focus appears stuck when switching between vertical tabs.
    // Calling e.stopPropagation() on Tab prevents the event from reaching MDB Modal's
    // window listener; the browser then handles natural Tab movement within the pane.
    // Tab does NOT advance to the next pane — only the Next button does that.
    const handleTabKeyNavigation = (e) => {
        if (e.key !== 'Tab') return;
        // Prevent MDB Modal's window-level focus trap from intercepting Tab.
        // stopPropagation stops bubbling to window listeners but does NOT prevent
        // the browser's default Tab focus movement — only preventDefault() does that.
        e.stopPropagation();
    };

    const handlePreviousClick = () => {
        clearErrors();
        if (parseInt(currentStep) === 4) {
            setreloadassigned(true);
        } else if (parseInt(currentStep) === 7 && parseInt(portingType) === 2) {
            setreloadarea(true);
        }

        let tabs = ['tab1', 'tab2', 'tab3', 'tab4', 'tab5', 'tab7'];
        if (portingType === 2) {
            tabs = ['tab1', 'tab2', 'tab3', 'tab4', 'tab5', 'tab6', 'tab7'];
        } else if (portingType === 3) {
            if (currentStep === 4) {
                setskipFlag(0);
            }
            tabs = ['tab1', 'tab2', 'tab4', 'tab5', 'tab6'];
        }
        const currentIndex = tabs.indexOf(verticalActive);
        setcurrentStep(parseInt(currentStep) - 1);
        if (currentIndex > 0) {
            setVerticalActive(tabs[currentIndex - 1]);
            if (visitedTabs.includes(tabs[currentIndex - 1])) {
                setVisitedTabs(visitedTabs.filter(tab => tab !== tabs[currentIndex]));
                console.log("previous");
                console.log(visitedTabs);
            }
        }
    };

    console.log("destinationTypes ::::::::::::::::: " + JSON.stringify(destinationTypes));



    return (
        <>
            <form id='tabsOverride' onKeyDown={handleTabKeyNavigation}>
                <MDBRow className='no-hover overflow-hidden h-100'>
                    <MDBCol size={2} className='pe-0 mob-w-100'>
                        <MDBTabs className='flex-column text-center'>
                            <MDBTabsItem>
                                <MDBTabsLink tabIndex={-1} active={verticalActive === 'tab1'} className={visitedTabs.includes('tab1') ? 'bg-success bg-opacity-25' : ''}>
                                    Enter Number(s)
                                </MDBTabsLink>
                            </MDBTabsItem>
                            <MDBTabsItem>
                                <MDBTabsLink tabIndex={-1} active={verticalActive === 'tab2'} className={visitedTabs.includes('tab2') ? 'bg-success bg-opacity-25' : ''}>
                                    Review Number(s)
                                </MDBTabsLink>
                            </MDBTabsItem>
                            {portingType !== 3 && (
                                <MDBTabsItem>
                                    <MDBTabsLink tabIndex={-1} active={verticalActive === 'tab3'} className={visitedTabs.includes('tab3') ? 'bg-success bg-opacity-25' : ''}>
                                        Assign Number(s) to Respective Destination(s)
                                    </MDBTabsLink>
                                </MDBTabsItem>
                            )}

                            <MDBTabsItem>
                                <MDBTabsLink tabIndex={-1} active={verticalActive === 'tab4'} className={visitedTabs.includes('tab4') ? 'bg-success bg-opacity-25' : ''}>
                                    Enter Account Info
                                </MDBTabsLink>
                            </MDBTabsItem>
                            <MDBTabsItem>
                                <MDBTabsLink tabIndex={-1} active={verticalActive === 'tab5'} className={visitedTabs.includes('tab5') ? 'bg-success bg-opacity-25' : ''}>
                                    Enter Service Address
                                </MDBTabsLink>
                            </MDBTabsItem>
                            <MDBTabsItem>
                                {portingType === 2 && (
                                    <MDBTabsLink tabIndex={-1} active={verticalActive === 'tab6'} className={visitedTabs.includes('tab6') ? 'bg-success bg-opacity-25' : ''}>
                                        Area of Service
                                    </MDBTabsLink>
                                )}
                            </MDBTabsItem>
                            {portingType !== 3 && (
                                <MDBTabsItem>
                                    <MDBTabsLink tabIndex={-1} active={verticalActive === 'tab7'} className={visitedTabs.includes('tab7') ? 'bg-success bg-opacity-25' : ''}>
                                        Notifications and comments
                                    </MDBTabsLink>
                                </MDBTabsItem>
                            )}
                        </MDBTabs>
                    </MDBCol>
                    <MDBCol size={9} className='pe-4 mob-w-100 flex-grow-1 flex-1 overflow-auto h-100'>
                        <MDBTabsContent>

                            <MDBTabsPane open={verticalActive === 'tab1'}>
                                {/* Home content */}
                                <div id="tn-pane-tab1">
                                <TransferNumbers
                                    register={register}
                                    errors={errors}
                                    watch={watch}
                                    setValue={setValue}
                                    clearErrors={clearErrors}
                                    portingType={portingType}
                                />
                                </div>

                            </MDBTabsPane>
                            <MDBTabsPane open={verticalActive === 'tab2'}>
                                {/* Profile content */}
                                <div id="tn-pane-tab2">
                                <ReviewNumbers
                                    register={register}
                                    watch={watch}
                                    portingNumbers={portingNumbers}
                                    handlePreviousClick={handlePreviousClick}
                                    portingType={portingType}
                                />
                                </div>
                            </MDBTabsPane>
                            <MDBTabsPane open={verticalActive === 'tab3'}>
                                <div id="tn-pane-tab3">
                                <NumbersToDestination
                                    register={register}
                                    errors={errors}
                                    watch={watch}
                                    setValue={setValue}
                                    destinationTypes={destinationTypes}
                                    assignedNumbersDetails={assignedNumbersDetails}
                                    assignedErrors={assignedErrors}
                                    setassignedNumbersDetails={setassignedNumbersDetails}
                                    setUpdateDestinationObj={setUpdateDestinationObj}
                                    updateDestinationObj={updateDestinationObj}
                                    setupdateTempNumObj={setupdateTempNumObj}
                                    updateTempNumObj={updateTempNumObj}
                                    reloadassigned={reloadassigned}
                                    setreloadassigned={setreloadassigned}
                                    setExeuteFlag={setExeuteFlag}
                                    executefalg={executefalg}
                                />
                                </div>
                            </MDBTabsPane>
                            <MDBTabsPane open={verticalActive === 'tab4'}>
                                <div id="tn-pane-tab4">
                                <NumbersAccountInfo
                                    register={register}
                                    errors={errors}
                                    watch={watch}
                                    setValue={setValue}
                                    portingType={portingType}
                                    clearErrors={clearErrors}
                                />
                                </div>
                            </MDBTabsPane>
                            <MDBTabsPane open={verticalActive === 'tab5'}>
                                <div id="tn-pane-tab5">
                                <NumbersServiceAddress
                                    register={register}
                                    errors={errors}
                                    watch={watch}
                                    setValue={setValue}
                                    portingType={portingType}
                                    clearErrors={clearErrors}
                                />
                                </div>
                            </MDBTabsPane>
                            {portingType === 2 && (
                                <MDBTabsPane open={verticalActive === 'tab6'}>
                                    <div id="tn-pane-tab6">
                                    <NumbersAreaService
                                        register={register}
                                        errors={errors}
                                        watch={watch}
                                        setValue={setValue}
                                        clearErrors={clearErrors}
                                        areaOfServiceDetails={areaOfServiceDetails}
                                        setareaOfServiceDetails={setareaOfServiceDetails}
                                        updateAllArea={updateAllArea}
                                        setupdateAllArea={setupdateAllArea}
                                        reloadarea={reloadarea}
                                        setreloadarea={setreloadarea}
                                        areaErrors={areaErrors}
                                        setAreaErrors={setAreaErrors}
                                    // control={control}
                                    />
                                    </div>
                                </MDBTabsPane>
                            )}
                            <MDBTabsPane open={verticalActive === 'tab7'}>
                                <div id="tn-pane-tab7">
                                <NumbersNotification
                                    register={register}
                                    errors={errors}
                                    watch={watch}
                                    setValue={setValue}
                                    clearErrors={clearErrors}

                                />
                                </div>
                            </MDBTabsPane>
                        </MDBTabsContent>
                    </MDBCol>
                </MDBRow>
                <MDBModalFooter className="d-flex justify-content-between pb-0">
                    <div className="d-flex">
                        {Object.keys(dirtyFields).length > 0 && isChanged && (
                            <MDBBtn color='secondary' className="text-normal-case" onClick={(e) => {
                                e.preventDefault();

                                handleSubmit(handleSaveDraft)();
                            }}>
                                Save to Draft
                            </MDBBtn>
                        )}
                    </div>
                    {/* <span id="draftsuccess"></span> */}
                    <div className="d-flex align-items-center">
                        {(parseInt(currentStep) === 3 || parseInt(currentStep) === 4) && portingType === 3 && (
                            <MDBBtn color='secondary' className='me-2' onClick={(e) => {
                                e.preventDefault();
                                handleSkip();
                            }
                            }>
                                Skip
                            </MDBBtn>
                        )}
                        {parseInt(currentStep) > 1 && (
                            <MDBBtn color='secondary' className='me-2' onClick={(e) => {
                                e.preventDefault();
                                handlePreviousClick();
                            }
                            }>
                                Previous
                            </MDBBtn>
                        )}
                        {/* {flowStep !== 7 ? (
                            <MDBBtn onClick={(e) => {
                                e.preventDefault();
                                handleSubmit(handleNextClick)();
                            }}>Next</MDBBtn>
                        ) : (
                            <MDBBtn onClick={nextPageclick}>Next</MDBBtn>
                        )} */}
                        <MDBBtn onClick={(e) => {
                            e.preventDefault();
                            handleSubmit(handleNextClick)();
                        }}>Next</MDBBtn>
                    </div>
                </MDBModalFooter>

                <MDBModal open={numberLimitAlert} onClose={() => setNumberLimitAlert(false)} tabIndex='-1'>
                    <MDBModalDialog centered>
                        <MDBModalContent className="border border-3 border-secondary shadow-4-strong rounded-3">
                            <MDBModalHeader>
                                <MDBModalTitle>Alert</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={(e) => {
                                    e.preventDefault();
                                    toggleOpen();
                                }}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody style={{ maxHeight: "60vh !important" }}>
                                <div className="d-flex flex-wrap align-items-center justify-content-start gap-2">
                                    <div>
                                        {alertMessage}
                                    </div>
                                    {alertnumbers && alertnumbers?.map((number, index) => (
                                        // <MDBChip key={index} className="me-1">
                                        <div key={index} className='d-inline-block pe-2'>
                                            {formattedNumber(number) + (index !== alertnumbers.length - 1 ? ", " : "")}
                                        </div>
                                        // </MDBChip>
                                    ))}
                                </div>

                            </MDBModalBody>

                            <MDBModalFooter>
                                <MDBBtn color='secondary' onClick={(e) => {
                                    e.preventDefault();
                                    clearErrors();
                                    toggleOpen();
                                }}>
                                    Cancel
                                </MDBBtn>
                                <MDBBtn onClick={(e) => {
                                    e.preventDefault();
                                    clearErrors();
                                    navigateNewTab(newTabObject);
                                    toggleOpen();
                                }}>OK</MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>
            </form >
        </>
    )
}
export default TNLocalStep1

